import React from 'react';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Cookie Policy</h1>
          <div className="prose max-w-none">
            <p className="text-gray-600 mb-6">Last updated: October 24, 2026</p>
            
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">What Are Cookies</h2>
            <p className="mb-6">Cookies are small text files that are stored on your device when you visit our website. They help us provide you with a better experience by remembering your preferences and improving our services.</p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">How We Use Cookies</h2>
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Essential Cookies</h3>
              <p className="mb-4">These cookies are necessary for the website to function properly:</p>
              <ul className="list-disc pl-6 mb-4">
                <li>Authentication and login status</li>
                <li>Security and fraud prevention</li>
                <li>Session management</li>
              </ul>

              <h3 className="text-lg font-semibold text-gray-800 mb-2">Functional Cookies</h3>
              <p className="mb-4">These cookies enhance your experience:</p>
              <ul className="list-disc pl-6 mb-4">
                <li>Remember your preferences and settings</li>
                <li>Personalize content and features</li>
                <li>Improve website performance</li>
              </ul>

              <h3 className="text-lg font-semibold text-gray-800 mb-2">Analytics Cookies</h3>
              <p className="mb-4">These cookies help us understand how you use our website:</p>
              <ul className="list-disc pl-6 mb-4">
                <li>Track website usage and performance</li>
                <li>Analyze user behavior and preferences</li>
                <li>Improve our services and user experience</li>
              </ul>

              <h3 className="text-lg font-semibold text-gray-800 mb-2">Product Analytics &amp; Session Recording (PostHog)</h3>
              <p className="mb-4">We use PostHog, a product-analytics provider, to understand how visitors navigate our site so we can improve it. PostHog may set cookies / local storage to:</p>
              <ul className="list-disc pl-6 mb-4">
                <li>Count page views and measure how visitors move through the site (including those who browse without creating an account)</li>
                <li>Automatically capture anonymized interaction events such as clicks and form submissions</li>
                <li>Generate aggregate heatmaps of clicks and scrolling</li>
                <li>Optionally record anonymized session replays — <strong>only if you consent</strong>. When enabled, all text and input fields are masked, so passwords, email addresses, and financial details are never captured. You can decline or withdraw this consent at any time.</li>
              </ul>
              <p className="mb-4">We honor your browser's "Do Not Track" setting. Session recording is disabled by default and is never started without your explicit consent.</p>
            </div>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Third-Party Cookies</h2>
            <p className="mb-4">We may use third-party services that set cookies on our website:</p>
            <ul className="list-disc pl-6 mb-6">
              <li><strong>Stripe:</strong> For secure payment processing</li>
              <li><strong>AWS:</strong> For website hosting and performance</li>
              <li><strong>PostHog:</strong> For product/web analytics, heatmaps, and (consent-based) anonymized session replay</li>
              <li><strong>Analytics providers:</strong> For website analytics and insights</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Managing Cookies</h2>
            <p className="mb-4">You can control and manage cookies in several ways:</p>
            <ul className="list-disc pl-6 mb-6">
              <li>Browser settings: Most browsers allow you to block or delete cookies</li>
              <li>Opt-out tools: Use third-party opt-out tools for analytics cookies</li>
              <li>Account settings: Manage preferences in your account dashboard</li>
            </ul>

            <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6">
              <p className="text-blue-800"><strong>Note:</strong> Disabling essential cookies may affect website functionality and your ability to use certain features.</p>
            </div>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Cookie Retention</h2>
            <p className="mb-6">Cookies are retained for different periods depending on their purpose:</p>
            <ul className="list-disc pl-6 mb-6">
              <li><strong>Session cookies:</strong> Deleted when you close your browser</li>
              <li><strong>Persistent cookies:</strong> Stored for a specific period (typically 30 days to 2 years)</li>
              <li><strong>Authentication cookies:</strong> Expire based on your login preferences</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Updates to This Policy</h2>
            <p className="mb-6">We may update this Cookie Policy from time to time. We will notify you of any significant changes by posting the new policy on this page.</p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Contact Us</h2>
            <p className="mb-4">If you have questions about our use of cookies, please contact us at:</p>
            <p className="mb-2">Email: privacy@gandalstock.com</p>
            <p className="mb-6">Address: GandalStock, Inc.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
